import { render, staticRenderFns } from "./stockSubmenu.vue?vue&type=template&id=37c0fb4a&"
import script from "./stockSubmenu.vue?vue&type=script&lang=ts&"
export * from "./stockSubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports